
















































































import { Component, Vue } from "vue-property-decorator";
import {
  getCheckExpertAppointmentList
} from "@/serve/expertAppointment/index";
import { Calendar } from "element-ui";
import { Card, Switch, TimePicker, TimeSelect } from "element-ui";
@Component({
  name: "companyManage",
  components: { Calendar, Card, Switch, TimePicker, TimeSelect },
})
export default class MedicalReport extends Vue {
  public itemDialog = false;
  public formData = {
    checkerName: "",
    expertName: "",
    state:"0",
    startDate: "",
    endDate: "",
    current: 1,
    size: 10,
  };
  //分页器参数
  public pagination = {
    //每页数量
    size: 0,
    //总页
    total: 0,
    //当前页
    current: 0,
  };
  public appointmentDate = ""
  public handleStartTimeChange(val: any) {
    this.formData.startDate = val[0];
    this.formData.endDate = val[1];
  }
  //日期选择器
  public value = new Date();
  //是否展示号源编辑框
  public dialogTime = false;
  public tableData = [];
  public created() {
    //获取列表
    this.getReportList();
  }
  // 点击左右箭头
  public handleSizeChange(val: any): void {
    this.formData.size = val;
    this.getReportList();
  }
  // 点击页码
  public handleCurrentChange(val: any): void {
    this.formData.current = val;
    this.getReportList();
  }
  // 获取数据接口
  public async getReportList() {

    getCheckExpertAppointmentList(this.formData).then((res: any) => {
      console.log("表格数据", res);
      this.tableData = res.data.records;
      this.pagination.size = res.data.size;
      this.pagination.total = res.data.total;
      this.pagination.current = res.data.current;
    });
  }
  // 筛选按钮
  public onSubmit() {
    this.getReportList();
  }

  //reset重置搜索框
  public reset() {
    this.formData.checkerName = "";
    this.formData.expertName = "";
    this.formData.state = "0";
    this.formData.startDate = "";
    this.formData.endDate = "";
    this.formData.current = 1;
    this.formData.size = 10;
    this.appointmentDate = "";
    this.getReportList();
  }

  // 下载表格
  private exportExcel() {
    const data: any = JSON.parse(JSON.stringify(this.formData)) 
    getCheckExpertAppointmentList(data).then((res: any) => {
      console.log("res", res);
      if (res.data.records.length > 0) {
        //  下面是原有的导出逻辑，现在使用 startTime 和 endTime 变量代替 form 中的值
        const link = document.createElement("a");
        link.href =
          process.env.VUE_APP_BASEURL +
          "/manage/checkExpertAppointment/exportResultExcel" +
          `?checkerName=${data.checkerName}&expertName=${data.expertName}&state=${data.state}&startDate=${data.startDate}&endDate=${data.endDate}`; // 注意这里如何将时间参数附加到URL上
        link.download = "filename.excel"; // 指定下载后的文件名
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // 清理工作
      } else {
        this.$message.error("没有查询到可以导出的数据");
      }
    });
  }
}
